import moment from "moment";

export const noticeDeadline = (endDate: string, noticePeriodMonths: number): string =>
  moment(endDate).subtract(noticePeriodMonths, "months").format("YYYY-MM-DD");
